'use strict';

/**
 * Model for a group
 *
 * @category   Model
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Model = require('base/Colido.Model');

var GroupModel = Model.extend({
    api: '/community/groups',

    defaults: function(){ //use function, cause objects are passed by reference
        return {
            creatorId: null, //Integer
            name: '', //String
            conversationId: null, //Integer
            created: null, //Integer
            users: [], //Array
            type: 'normal', //String [normal|broadcast]
        };
    },

    customAttributes: {
        conversation: function() {
            return App.CommunityModule.conversationsCollection.get(this.get('conversationId'));
        },

        conversationUrl: function() {
            var url = '/community/{type}/conversation/' + this.get('conversationId');

            var types = {
                normal: 'groups',
                broadcast: 'broadcasts',
            };

            return _.tpl(url, {type: types[this.get('type')]});
        },

        conversationLastMessage: function() {
            var conversation = this.get('conversation');

            return conversation ? conversation.get('lastMessage') ? conversation.get('lastMessage') : ''
                                : '';
        },
    },
});

module.exports = GroupModel;